import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./convidi.module.scss"

import SEO from "../../../components/seo"
import ProjectLayout from "../../../templates/project-page/ProjectLayout"
import ProjectGrid from "../../../components/UI/ProjectGrid"
import Image from "../../../components/UI/Image"


const Convidi: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<ProjectLayout
			title={`CONVIDI: \nConversational Commerce \nfor Increased Conversion `}
			date="2020"
			desktopImage="/images/projects/convidi/conv-title.png"
			mobileImage="/images/projects/convidi/m-conv-title.png"
			description={`With the growing popularity of online shopping, especially during the COVID-19 pandemic, shoppers are missing the live interaction and personal touch that characterizes offline shopping. \nCONVIDI is a platform that connects shoppers with sellers through video consultations right in online stores.`}
			client="Private Investor (EU)"
			expretise={`Full-cycle development \nDesign support \nAnalytics`}
			projectImage="/images/projects/convidi/title.png"
			location={location}
			back="white"
		>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "projects-new.list.convidi.description" })}
				title={intl.formatMessage({ id: "projects-new.list.convidi.metatitle" })}
				pathname={location.pathname}
			/>
			{/* Дополнительный контент */}
			<section className={styles.objective}>
				<h2>Objective</h2>
				<div className={styles.objectiveSubtitle}><p>{`Create a solution that builds trust in online shopping and improves the user experience through:`}</p></div>
				<ProjectGrid
					className={styles.objectiveGrid}
					number
					listItems={[
						{ title: "Personalized video advice;" },
						{ title: "Intelligent recommendations based on purchase history;" },
						{ title: "Live interaction, allowing the salesperson to help with selection, show the product, and select the size." },
					]}
				/>
				<div className={styles.objectiveGridText}>
					<h2>
						{`Challenges exacerbated during the COVID-19 period`}
					</h2>
				</div>
				<div className={styles.objectiveGridText}>
					<p>{`The pandemic dramatically accelerated the digitalization of commerce, but revealed and exacerbated a number of problems:`}</p>
				</div>
				<ProjectGrid
					rows
					listItems={[
						{ title: "Low conversion rates - traffic growth was not matched by sales growth;" },
						{ title: "Poor user experience with chatbots - automated systems often failed to handle real customer inquiries;" },
						{ title: "High rate of returns - especially in clothing and footwear categories, where customers could not choose the right size or did not understand how the product looked in person;" },
						{ title: "Ineffective recommendation functionality - one-size-fits-all offers without context or customer history didn't incentivize purchase;" },
						{ title: "These challenges were the starting point for the development of CONVIDI - a platform focused on personalization, live interactions and accurate recommendations." },
					]}
				/>
				<div className={styles.objectiveImg}><Image src="/images/projects/convidi/objective-1.png" alt="Audit: busuness card" fill /></div>
			</section>
			<section className={styles.solution}>
				<h2>Solution</h2>
				<div className={styles.solutionSubtitle}>
					<p>
						The CONVIDI platform includes:
					</p>
				</div>
				<p className={styles.solutionText}>
					For the seller (admin panel):
				</p>
				<ProjectGrid
					rows
					listItems={[
						{ title: "Viewing order history and customer preferences;" },
						{ title: "Automated recommendations;" },
						{ title: "Video interface for consultation;" },
						{ title: "Analytics tools (session time, conversion, customer scores);" },
						{ title: "Flexible customization of schedules and notifications." },
					]}
				/>
				<div className={styles.solutionImg}><Image src="/images/projects/convidi/solution-1.png" alt="UI kit \ User flow" fill /></div>
				<h3>For the shopper:</h3>
				<ProjectGrid
					rows
					listItems={[
						{ title: "Quick access to a video consultation with a salesperson;" },
						{ title: "Recommendations based on personal shopping history;" },
						{ title: "Assistance in selecting sizes, styles, analogs;" },
						{ title: "Adding items to the shopping cart right during the session." },

					]}
				/>
				<div className={styles.solutionImgLarge}><Image src="/images/projects/convidi/solution-2.png" alt="Audit: busuness card" fill /></div>
			</section>
			<section className={styles.result}>
				<h2>Result</h2>
				<div className={styles.resultSubtitle}>
					<p>Today CONVIDI is a beta version of a practical solution for online business, able to solve typical problems in the E-com industry and get loyal customers. This project has successfully solved all the client's challenges and needs, retaining current customers and attracting new ones. Thanks to CONVIDI, our clients have improved their KPIs.</p>
				</div>
				<ProjectGrid
					className={styles.resultTextWhite}
					bg="orange"
					listItems={[
						{ percent: "-19%", title: "Reduced returns through accurate product selection." },
						{ title: "Developed a design that can be customized to meet the requirements of new clients." },
						{ title: "Salespersons noted a reduction in lead time due to AI recommendations." },
					]}
				/>
			</section>
		</ProjectLayout>

	)
}

export default Convidi;
